/**
 * Public-facing reviewer name: first name plus last initial ("Abde K.").
 * Used as the default display name on guest reviews, and pre-filled into the
 * review form so the API default and the UI can never drift.
 */
export function shortDisplayName(
  firstName?: string | null,
  lastName?: string | null,
): string {
  const first = (firstName ?? "").trim().replace(/\s+/g, " ");
  const last = (lastName ?? "").trim().replace(/\s+/g, " ");
  if (!first && !last) return "Guest";
  if (!first) return last;
  if (!last) return first;
  const initial = [...last][0] ?? "";
  return `${first} ${initial.toUpperCase()}.`;
}
